<script setup lang="ts">
import type { File } from "@gasparigit/omnia-sdk";
import { link } from "~/lib/utils/contents";
import Attach from "../icons/Attach.vue";

const props = defineProps<{
  fileId: number;
  text: string;
}>();

const file = computed(() => ({ id: props.fileId } as File));
</script>

<template>
  <FrontDownloadButton :file-id="fileId" class="gap-1">
    <a
      @click.prevent="() => {}"
      target="_blank"
      :href="link({ file: file })"
      class="inline-flex items-center bg-muted\80 rounded-lg mx-1 ps-1 pe-2 no-underline font-semibold border border-primary-800\5 print:border-none print:mx-0 print:p-0 print:font-normal"
    >
      <Attach class="size-5 print:hidden" />
      <span v-html="text"></span>
    </a>
  </FrontDownloadButton>
</template>
